import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import ShowcaseHeader from '../../../layouts/showcaseLayouts/ShowcaseHeader/ShowcaseHeader';
// import ShowcaseFooter from '../../../layouts/showcaseLayouts/ShowcaseFooter/ShowcaseFooter';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import Header from '../../../shared/Header/Header';
// import BackButton from '../../../shared/backButton/BackButton';
import Footer from '../../../shared/Footer/Footer';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
// import AuthForm from './components/AuthForm';
// import SignInForm from './components/SignInForm';
// import RegInForm from './components/RegInForm';
// import UserCard from './components/UserCard';
import UserCardNew from './components/new/UserCardNew';
import useIsLTE650 from '../../../../hooks/useIsLTE650';
import classes from './AccountPage.module.css';

const AccountPage: React.FC = () => {
    // Состояние авторизации, устанавливается по результату запроса к защищённому маршруту
    const navigate = useNavigate();
    const isMobile = useIsLTE650(650);
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(true);

    // Состояние выбора формы (вход/регистрация)
    // const [
    //     authForm,
    // ] = useState(true);
    // const [consent, setConsent] = useState(true);
    // const [terms, setTerms] = useState(true);

    // Состояния для валидации формы входа (signIn)
    // const [
    //     signInErrors,
    // ] = useState<{ [key: string]: string }>({});

    // Состояния для регистрации
    // const [fullName, setFullName] = useState('');
    // const [phone, setPhone] = useState('');
    // const [email, setEmail] = useState('');
    // const [password, setPassword] = useState('');
    // const [confirmPassword, setConfirmPassword] = useState('');
    // const [regErrors, setRegErrors] = useState<{ [key: string]: string }>({});

    // Функция для проверки авторизации через запрос к защищённому маршруту
    const checkAuthStatus = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/protected`, {
                method: 'GET',
                credentials: 'include',
            });
            if (response.ok) {
                setIsLoggedIn(true);
            } else {
                setIsLoggedIn(false);
            }
        } catch (error) {
            console.error('Ошибка проверки авторизации:', error);
            setIsLoggedIn(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Проверяем статус авторизации при монтировании компонента
        checkAuthStatus();
    }, []);

    useEffect(() => {
        if (loading) return;
        if (isLoggedIn) return;
        navigate('/', { replace: true });
    }, [loading, isLoggedIn, navigate]);

    // Пока идет проверка авторизации, отображаем индикатор загрузки
    if (loading) {
        return (
            <div className={classes.accountPage}>
                <Header />
                <SectionHeader title={'Личный кабинет'} />
                <SectionBody>
                    <div style={{ textAlign: 'center', padding: '50px' }}>Загрузка...</div>
                </SectionBody>
                <Footer />
            </div>
        );
    }

    if (!isLoggedIn) {
        return null;
    }

    return (
        <div className={classes.accountPage}>
            <Header isMobile={isMobile} />
            <div
                className={classes.headerWrapper + (isMobile && !mobileMenuOpen ? ` ${classes.headerWrapperMobileDisabled}` : '')}
                onClick={isMobile ? () => setMobileMenuOpen((prev) => !prev) : undefined}
            >
                {/* <BackButton absolute /> */}
                {/* <SectionHeader title={'Личный кабинет'} /> */}
                <div
                    className={
                        classes.headerTitle + (isMobile && mobileMenuOpen ? ` ${classes.headerTitleMobileActiv}` : isMobile ? ` ${classes.headerTitleMobile}` : '')
                    }
                >
                    <h1 className={classes.headerTitleValue}>Личный кабинет</h1>
                </div>
            </div>
            <SectionBody>
                <UserCardNew setIsLoggedIn={setIsLoggedIn} isMobile={isMobile} mobileMenuOpen={mobileMenuOpen} />
                {/* {isLoggedIn ? (
                    <UserCardNew setIsLoggedIn={setIsLoggedIn} />
                ) : (
                    <div className={classes['accountPage-formWrapper']}>
                        <div className={classes['accountPage-formWrapper-header']}>
                            <h3 className={classes['accountPage-formWrapper-signIn']}>{authForm ? 'Вход' : 'Регистрация'}</h3>
                        </div>
                        {authForm ? (
                            <AuthForm
                                setIsLoggedIn={setIsLoggedIn}
                                consent={consent}
                                setConsent={setConsent}
                                terms={terms}
                                setTerms={setTerms}
                                signInErrors={signInErrors}
                            />
                        ) : (
                            <RegInForm
                                fullName={fullName}
                                setFullName={setFullName}
                                phone={phone}
                                setPhone={setPhone}
                                email={email}
                                setEmail={setEmail}
                                password={password}
                                setPassword={setPassword}
                                confirmPassword={confirmPassword}
                                setConfirmPassword={setConfirmPassword}
                                regErrors={regErrors}
                                setRegErrors={setRegErrors}
                                consent={consent}
                                setConsent={setConsent}
                            />
                        )}
                    </div>
                )} */}
            </SectionBody>
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default AccountPage;
